import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import advancedPotionMaking from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy";
import advancedPotionMakingV3 from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy/v3";
import backgroundImage from "./gallery/promo_03.jpg";
import { routes } from "config";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.05,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        While creating the full{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", advancedPotionMaking.id).replace(":version", `v${advancedPotionMakingV3.version}`)}`}
          target="_blank"
        >
          Advanced Potion-Making v3
        </Link>
        , I ended up with several spare covers left, since I was originally
        planning to create more full prop replicas. I had to drop the final
        number a bit due to time constraints and the sheer scale of the project,
        so, rather than let them go to waste or have them gather dust in a box,
        I've decided to create a DIY version - that is, to pair each cover with
        a 3D-printed book block that simulates the layered paper sheets. This
        way, this 'DIY' cover version works in two ways. First, it functions as
        a lightweight alternative to the full prop — from the outside, the cover
        looks completely identical to the complete version, giving you all the
        visual appeal if all you want is a decoration to put on the shelf, or
        even use it as a box to hide things inside. Second, and perhaps more
        importantly, the cover can be easily separated from the 3D-printed
        block, allowing you to mount it onto your own book block - either of a
        preexisting book or a custom one - allowing you to use this as sort-of
        do-it-yourself kit to create your own full prop replica.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="300px"
        imageOptions={[{ index: 5, aspectRatio: 1.7 }]}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        The design of the cover maintains all the visual fidelity of the
        original prop, with the 3D-printed block serving as a placeholder for
        the actual book block. As mentioned above, the cover can be easily
        removed from the block - since I made this to be taken apart, the cover
        is attached to the 3D printed block with just four small pieces of
        double-sided tape in each corner, so, with enough care, you can easily
        peel it off without damaging the canvas of the cover. Once the cover is
        removed, you can then stick it onto your own book block and voilà -
        you've got yourself a full prop of the Advanced Potion-Making!
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={1}
        aspectRatio={1}
        imageMaxHeight="400px"
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        Please note that this is not a final 'product' - while it can be used as
        a standalone decoration, it is primarily intended as a DIY kit for
        people to create their own full prop replicas without the means of
        creating the intricate cover.
      </ReplicaParagraph>
    </ReplicaContent>
  );
};

export default Page;
export { background };
